import abstractModel from '../../core/ShopModel';

let resource = 'retailers/orders';

const model = abstractModel(resource);

model.getOne = async (params) => {
  const newResource = `${resource}/${params.id}`;

  return model.get({}, { path: newResource });
};

model.getDownloadHistory = async (params) => {
  const newResource = `${resource}/download_histories`;

  return model.get(params, { path: newResource });
};

export default model;
